import { render, staticRenderFns } from "./store-dialog.vue?vue&type=template&id=afc22c36"
import script from "./store-dialog.vue?vue&type=script&lang=js"
export * from "./store-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports